import store from '@/store';

export default class WhatsAppTransferInboxEvent {
  constructor(body) {
    store.dispatch('jobs/endWhatsAppInbox', body.protocol);
  }
}
